"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var logLevel_1 = require("./logLevel");
var config_1 = require("./config");
var logger_1 = require("./logger");
var scheduler_1 = require("./scheduler");
var settings_1 = require("./settings");
var sdkStarted_1 = require("./sdkStarted");
var event_1 = require("./event");
var globals_1 = require("./globals");
var utils_1 = require("./utils");
var beacon_1 = require("./beacon");
var appLaunched_1 = require("./appLaunched");
var errorCreated_1 = require("./errorCreated");
var screenViewed_1 = require("./screenViewed");
var trackingStopped_1 = require("./trackingStopped");
var checkpoint_1 = require("./checkpoint");
var appBackground_1 = require("./appBackground");
var appForeground_1 = require("./appForeground");
var remoteConfig_1 = require("./remoteConfig");
var appState_1 = require("./appState");
var DiveSDK = /** @class */ (function () {
    function DiveSDK(diveConfig) {
        var _this = this;
        this.env = "";
        this.game_ver = "";
        this.current_level = 0;
        this.player_xp = 0;
        this.player_id = "";
        this.s_sessionid = "";
        this.sdkStarted = false;
        this.appLauchedSent = false;
        this.remoteConfig = new remoteConfig_1.DiveRemoteConfig();
        this.beaconScheduler = new scheduler_1.default(function () { });
        this.token = diveConfig.AppToken;
        this.env = diveConfig.Environment;
        this.game_ver = diveConfig.GameVersion;
        config_1.default.getInstance(diveConfig);
        logger_1.default.getInstance(diveConfig.Logger, diveConfig.ShowLogs);
        settings_1.default.getInstance(diveConfig.AppToken);
        this.initSettings().then(function () {
            if (!_this.trackingStopped()) {
                logger_1.default.getInstance().add("SDK initializated", logLevel_1.default.INFO);
            }
            else {
                logger_1.default.getInstance().add("SDK is Opt Out. Cal SetOptOut(false) and call Init ", logLevel_1.default.INFO);
            }
            if (settings_1.default.getInstance().get("is_background_tracking_enabled")) {
                appState_1.default
                    .getInstance()
                    .onBackground(function () { return _this.appBackground(); })
                    .onForeground(function () { return _this.appForeground(); });
            }
        });
    }
    Object.defineProperty(DiveSDK.prototype, "SdkStarted", {
        get: function () { return this.sdkStarted; },
        enumerable: false,
        configurable: true
    });
    ;
    DiveSDK.prototype.initSettings = function () {
        var _this = this;
        this.onSettingsLoaded = settings_1.default.getInstance()
            .init()
            .then(function () {
            _this.begin();
        });
        return this.onSettingsLoaded;
    };
    DiveSDK.prototype.SetOptOut = function (opt) {
        var _this = this;
        var trackingStopped = utils_1.default.getCookie(utils_1.default.TRACKING_STOPPED_KEY);
        if (opt) {
            if (trackingStopped === null) {
                var event = new trackingStopped_1.default();
                if (this.s_sessionid) {
                    event.SetServerSessionId(this.s_sessionid);
                }
                if (this.token) {
                    event.SetAppToken(this.token);
                }
                if (this.env) {
                    event.SetEnv(this.env);
                }
                if (this.game_ver) {
                    event.SetGameVersion(this.game_ver);
                }
                if (this.player_id) {
                    event.SetPlayerId(this.player_id);
                }
                if (this.current_level) {
                    event.SetPlayerLevel(this.current_level);
                }
                if (this.player_xp) {
                    event.SetPlayerXp(this.player_xp);
                }
                if (this.s_sessionid) {
                    event.SetServerSessionId(this.s_sessionid);
                }
                this.postEvent(event)
                    .then(function () {
                    _this.beaconScheduler.stop();
                    utils_1.default.setCookie(utils_1.default.TRACKING_STOPPED_KEY, true, 0);
                })
                    .catch(function (e) {
                    logger_1.default.getInstance().add("Error sending the event " + event.getName() + " " + JSON.stringify(event.toJson(), null, 2) + " via fallback url. Error says \"" + e + "\"", logLevel_1.default.WARNING);
                });
            }
        }
        else {
            if (trackingStopped) {
                utils_1.default.removeCookie(utils_1.default.TRACKING_STOPPED_KEY);
            }
        }
        return this;
    };
    DiveSDK.prototype.SetDiveCid = function (cid) {
        utils_1.default.setCookie(utils_1.default.DIVE_CID_KEY, cid, this.getSessionLifeTimeSec());
    };
    DiveSDK.prototype.trackingStopped = function () {
        var trackingStopped = utils_1.default.getCookie(utils_1.default.TRACKING_STOPPED_KEY);
        return (trackingStopped !== null && trackingStopped);
    };
    DiveSDK.Init = function (config) {
        if (DiveSDK.instance) {
            logger_1.default.getInstance().add("DiveSDK Instance is already running. Re-initializing SDK", logLevel_1.default.INFO);
            this.reset();
        }
        return this.init(config);
    };
    DiveSDK.init = function (config) {
        if (!config || !config.AppToken || !config.HashKey) {
            logger_1.default.getInstance({
                level: logLevel_1.default.ERROR,
            }).add("You must set AppToken and HashKey", logLevel_1.default.ERROR);
        }
        if (config && !config.GameVersion) {
            logger_1.default.getInstance({
                level: logLevel_1.default.WARNING,
            }).add("Missing parameter GameVersion. You must set GameVersion when calling DiveSDK.Init().", logLevel_1.default.WARNING);
        }
        DiveSDK.instance = new DiveSDK(__assign(__assign({}, this.DEFAULT_CONFIG), config));
        return DiveSDK.instance;
    };
    DiveSDK.reset = function () {
        checkpoint_1.default.Reset();
        DiveSDK.instance.player_xp = 0;
        DiveSDK.instance.game_ver = "";
        DiveSDK.instance.player_id = "";
        DiveSDK.instance.current_level = 0;
        DiveSDK.instance.s_sessionid = "";
        DiveSDK.instance.ResetCustomHeaders();
        DiveSDK.instance.beaconScheduler.stop();
        utils_1.default.setClientSessionRestartedFromIdCookie();
        utils_1.default.removeDiveCookies();
    };
    DiveSDK.getInstance = function () {
        if (!DiveSDK.instance) {
            throw new Error("Method DiveSdk.getInstance(token,settings) is deprecated. Call DiveSdk.Init(settings) now. Then, you can use DiveSdk.getInstance() (without parameters) to get the initializated instance");
        }
        return DiveSDK.instance;
    };
    DiveSDK.prototype.begin = function () {
        var _this = this;
        if (!this.trackingStopped()) {
            this.sdkStarted = true;
            if (utils_1.default.firstSession() && utils_1.default.isClient()) {
                this.refreshClientSessionIdCookie();
                this.RecordEvent(new sdkStarted_1.default());
            }
            this.onSettingsLoaded.then(function () {
                _this.refreshClientSessionIdCookie();
                _this.initBeaconScheduler();
                var apiUrl = settings_1.default.getInstance().getApiURL();
                if (apiUrl != "")
                    config_1.default.getInstance().setApiURL(apiUrl);
                if (settings_1.default.getInstance().get("is_clean_orphan_cookies_enabled")) {
                    logger_1.default.getInstance().add('Running device_id patch', logLevel_1.default.DEBUG);
                    utils_1.default.patchCookie(settings_1.default.getInstance().get("is_clean_orphan_cookies_enabled") === 1);
                }
            });
            utils_1.default.processQueryStringParams(this.getSessionLifeTimeSec());
        }
    };
    DiveSDK.prototype.SetPlayerXp = function (currentXp) {
        this.player_xp = currentXp;
        return this;
    };
    DiveSDK.prototype.SetGameVersion = function (gameVersion) {
        this.game_ver = gameVersion;
        return this;
    };
    DiveSDK.prototype.SetPlayerId = function (playerID) {
        this.player_id = playerID;
        return this;
    };
    DiveSDK.prototype.SetPlayerLevel = function (currentLevel) {
        this.current_level = currentLevel;
        return this;
    };
    DiveSDK.prototype.SetServerSessionId = function (sessionID) {
        this.s_sessionid = sessionID;
        return this;
    };
    DiveSDK.prototype.SetCustomHeaderParam = function (param, value) {
        logger_1.default.getInstance().add("Set Custom Headers for all events -> " + param + " : " + value + ".", logLevel_1.default.INFO);
        event_1.default.SetCustomHeaderParam(param, value);
        return this;
    };
    DiveSDK.prototype.ResetCustomHeaders = function () {
        event_1.default.ResetCustomHeaders();
    };
    DiveSDK.prototype.ensureMissingSetters = function () {
        if (!this.s_sessionid || !this.s_sessionid.length) {
            logger_1.default.getInstance().add("Missing parameter s_session_id. You must call SetServerSessionId before call Launch.", logLevel_1.default.WARNING);
        }
        if (!this.player_id || !this.player_id.length) {
            logger_1.default.getInstance().add("Missing parameter player_id. You must call SetPlayerId before call Launch.", logLevel_1.default.WARNING);
        }
        return this;
    };
    DiveSDK.prototype.GetDeviceId = function () {
        return utils_1.default.getDeviceId();
    };
    DiveSDK.prototype.Launch = function (customParams) {
        if (!this.trackingStopped()) {
            this.ensureMissingSetters();
            var appLaunched = new appLaunched_1.default();
            if (customParams) {
                appLaunched._mergeEventBody(customParams);
            }
            if (this.appLauchedSent) {
                logger_1.default.getInstance().add("The launch method is being called more than once.", logLevel_1.default.WARNING);
            }
            this.appLauchedSent = true;
            return DiveSDK.getInstance().RecordEvent(appLaunched);
        }
        return this;
    };
    DiveSDK.prototype.RecordError = function (code, description) {
        if (!this.trackingStopped()) {
            var errorCreated = new errorCreated_1.default();
            errorCreated
                .SetCode(code)
                .SetDescription(description);
            return DiveSDK.getInstance().RecordEvent(errorCreated);
        }
        return this;
    };
    DiveSDK.prototype.ScreenViewed = function (viewed) {
        if (!this.trackingStopped()) {
            var screenViewed = new screenViewed_1.default();
            screenViewed
                .SetViewed(viewed, this.getSessionLifeTimeSec());
            return DiveSDK.getInstance().RecordEvent(screenViewed);
        }
        return this;
    };
    DiveSDK.prototype.refreshViewedBeforeKey = function () {
        utils_1.default.refreshCookieIfExists(utils_1.default.VIEWED_BEFORE_KEY, this.getSessionLifeTimeSec());
        return this;
    };
    DiveSDK.prototype.refreshClientSessionIdCookie = function () {
        utils_1.default.setClientSessionIdCookie(this.getSessionLifeTimeSec());
        return this;
    };
    DiveSDK.prototype.refreshAllDiveCookies = function () {
        utils_1.default.refreshAllDiveCookies(this.getSessionLifeTimeSec());
        return this;
    };
    DiveSDK.prototype.getSessionLifeTimeSec = function () {
        return settings_1.default.getInstance().get("session_lifetime_sec") ? settings_1.default.getInstance().get("session_lifetime_sec") : 15 * 60;
    };
    DiveSDK.prototype.initBeaconScheduler = function () {
        var _this = this;
        if (!this.trackingStopped() && utils_1.default.isClient()) {
            this.beaconScheduler = new scheduler_1.default(function () {
                _this
                    .refreshClientSessionIdCookie()
                    .refreshViewedBeforeKey()
                    .refreshAllDiveCookies();
                if (settings_1.default.getInstance().get("is_beacon_enabled", 0)) {
                    _this.RecordEvent(new beacon_1.default());
                }
            }, { repeating_time: settings_1.default.getInstance().get("beacon_freq_sec", 5) * 1000 }).start();
        }
    };
    DiveSDK.prototype.postEvent = function (event) {
        var _a;
        if (!this.trackingStopped()) {
            var origin_1 = "*";
            if (typeof window != 'undefined') {
                origin_1 = window.location.origin;
            }
            var requestBody = JSON.stringify([event.toJson()]);
            return fetch(settings_1.default.getInstance().get("tracking_url") + globals_1.default.events_path, {
                method: 'POST',
                body: requestBody,
                headers: (_a = {
                        'Authorization': "Bearer " + this.token
                    },
                    _a[globals_1.default.DIGEST_KEY] = utils_1.default.digest(requestBody, config_1.default.getInstance().getHashKey()),
                    _a['Content-type'] = 'application/json',
                    _a['origin'] = origin_1,
                    _a)
            })
                .then(function (response) {
                if (response.status === 404) {
                    logger_1.default.getInstance().add("There was an error trying to send the event. Server return status code 404", logLevel_1.default.WARNING);
                }
                else {
                    logger_1.default.getInstance().add("Event " + event.getName() + " " + JSON.stringify(event.toJson(), null, 2) + " sent", logLevel_1.default.INFO);
                }
            });
        }
        return new Promise(function () { });
    };
    DiveSDK.prototype.postEventFallback = function (event) {
        var _a;
        if (!this.trackingStopped()) {
            var origin_2 = "*";
            if (typeof window != 'undefined') {
                origin_2 = window.location.origin;
            }
            var requestBody = JSON.stringify([event.toJson()]);
            return fetch(config_1.default.getInstance().getAnalyticsURL() + globals_1.default.events_path, {
                method: 'POST',
                body: requestBody,
                headers: (_a = {
                        'Authorization': "Bearer " + this.token
                    },
                    _a[globals_1.default.DIGEST_KEY] = utils_1.default.digest(requestBody, config_1.default.getInstance().getHashKey()),
                    _a['Content-type'] = 'application/json',
                    _a['origin'] = origin_2,
                    _a)
            })
                .then(function (response) {
                if (response.status === 404) {
                    logger_1.default.getInstance().add("Error sending the event " + event.getName() + " " + JSON.stringify(event.toJson(), null, 2) + " via fallback url. Response code: " + response.status, logLevel_1.default.WARNING);
                }
                else {
                    logger_1.default.getInstance().add("Event " + event.getName() + " " + JSON.stringify(event.toJson(), null, 2) + " sent to fallback url", logLevel_1.default.INFO);
                }
            }).catch(function (e) {
                logger_1.default.getInstance().add("Error sending the event " + event.getName() + " " + JSON.stringify(event.toJson(), null, 2) + " via fallback url. Error says \"" + e + "\"", logLevel_1.default.WARNING);
            });
        }
        return this;
    };
    DiveSDK.prototype.RecordEvent = function (param1, param2) {
        var _this = this;
        if (!this.trackingStopped() && utils_1.default.isClient()) {
            this.onSettingsLoaded.then(function () {
                return _this.sendEvent(param1, param2);
            });
        }
        return this;
    };
    DiveSDK.prototype.StartCheckpoint = function (name) {
        if (!this.trackingStopped()) {
            var checkpointEvent = checkpoint_1.default.Start(name);
            if (checkpointEvent)
                DiveSDK.getInstance().RecordEvent(checkpointEvent);
        }
        return this;
    };
    DiveSDK.prototype.EndCheckpoint = function (name) {
        if (!this.trackingStopped()) {
            var checkpointEvent = checkpoint_1.default.End(name);
            if (checkpointEvent)
                DiveSDK.getInstance().RecordEvent(checkpointEvent);
        }
        return this;
    };
    DiveSDK.prototype.appBackground = function () {
        var backgroundTrackingEnabled = settings_1.default.getInstance().get('background_tracking_enabled', true);
        if (!this.trackingStopped() && backgroundTrackingEnabled) {
            checkpoint_1.default.StartDowntime();
            var appBackground = new appBackground_1.default();
            DiveSDK.getInstance().RecordEvent(appBackground);
        }
    };
    DiveSDK.prototype.appForeground = function () {
        var backgroundTrackingEnabled = settings_1.default.getInstance().get('background_tracking_enabled', true);
        if (!this.trackingStopped() && backgroundTrackingEnabled) {
            checkpoint_1.default.EndDowntime();
            var appForeground = new appForeground_1.default();
            DiveSDK.getInstance().RecordEvent(appForeground);
        }
    };
    DiveSDK.prototype.sendEvent = function (param1, param2) {
        var _this = this;
        if (!this.trackingStopped()) {
            var event_2 = param1 instanceof event_1.default ? param1 : new event_1.default(param1, param2 || {});
            if (this.token) {
                event_2.SetAppToken(this.token);
            }
            if (this.env) {
                event_2.SetEnv(this.env);
            }
            if (this.game_ver) {
                event_2.SetGameVersion(this.game_ver);
            }
            if (this.player_id) {
                event_2.SetPlayerId(this.player_id);
            }
            if (this.current_level) {
                event_2.SetPlayerLevel(this.current_level);
            }
            if (this.player_xp) {
                event_2.SetPlayerXp(this.player_xp);
            }
            if (this.s_sessionid) {
                event_2.SetServerSessionId(this.s_sessionid);
            }
            // if(this.platform) {event.SetPlatform(this.platform); }
            if (settings_1.default.getInstance().get("is_sdk_enabled") === 1) {
                try {
                    this
                        .postEvent(event_2)
                        .catch(function (e) {
                        logger_1.default.getInstance().add("Event " + event_2.getName() + " submission failed. Error says \"" + e + "\"", logLevel_1.default.WARNING);
                        var retries = new scheduler_1.default(function (iterator) {
                            logger_1.default.getInstance().add("Implementing event submission retries. Retrie number: " + iterator, logLevel_1.default.DEBUG);
                            _this
                                .postEvent(event_2)
                                .then(function () { retries.stop(); })
                                .catch(function (error) {
                                logger_1.default.getInstance().add("Event resubmission failed on retrie number: " + iterator + ". Server says " + error, logLevel_1.default.WARNING);
                            });
                        }, {
                            repeating_time: settings_1.default.getInstance().get("retries_sleep_sec") * 1000,
                            iterations: settings_1.default.getInstance().get("retries_no")
                        });
                        retries.start();
                        return _this;
                    });
                }
                catch (error) {
                    logger_1.default.getInstance().add("Event submission failed. Error says " + error, logLevel_1.default.WARNING);
                }
            }
            else if (settings_1.default.getInstance().get("is_sdk_enabled") === null) {
                if (config_1.default.getInstance().getAnalyticsURL()) {
                    this.postEventFallback(event_2);
                }
                if (!utils_1.default.isClient()) {
                    if (settings_1.default.getInstance().hasResults() === false) {
                        this.initSettings();
                    }
                }
            }
        }
        return this;
    };
    DiveSDK.prototype.GetRemoteConfig = function (playerId, onSuccess, onFail) {
        var _this = this;
        if (config_1.default.getInstance().getApiURL() === null || config_1.default.getInstance().getApiURL() === undefined || config_1.default.getInstance().getApiURL() === "") {
            logger_1.default.getInstance().add("ApiURL is not set. Add ApiURL to RemoteSettings and Re-initialize SDK", logLevel_1.default.WARNING);
            return onFail("ApiURL is not set. Add ApiURL to RemoteSettings and Re-initialize SDK");
        }
        var config = this.loadRemoteConfig(null);
        if (this.remoteConfig.loaded && config !== null) {
            onSuccess(config);
            return;
        }
        var url = config_1.default.getInstance().getApiURL() + "/remoteConfig/player?api_key=" + this.token + "&player_id=" + playerId;
        try {
            this.fetchRemoteConfig(url)
                .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                var json;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (response.status === 404) {
                                logger_1.default.getInstance().add("Fetching " + url + " Failed With Status 404", logLevel_1.default.WARNING);
                            }
                            return [4 /*yield*/, response.json()];
                        case 1:
                            json = _a.sent();
                            logger_1.default.getInstance().add("Config Server responded: " + JSON.stringify(json, null, 2), logLevel_1.default.DEBUG);
                            config = this.loadRemoteConfig(json);
                            return [2 /*return*/, config !== null ? onSuccess(config) : onFail("Fetching Remote Config From " + url + " Failed With Status 404")];
                    }
                });
            }); })
                .catch(function (e) {
                logger_1.default.getInstance().add("Fetching Remote Config Failed. Error says \"" + e + "\"", logLevel_1.default.WARNING);
                var retries = new scheduler_1.default(function (iterator) {
                    logger_1.default.getInstance().add("Fetching Remote Config retries. Retry number: " + iterator, logLevel_1.default.DEBUG);
                    _this.fetchRemoteConfig(url)
                        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                        var json;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (response.status === 404) {
                                        logger_1.default.getInstance().add("Fetching " + url + " Failed With Status 404", logLevel_1.default.WARNING);
                                    }
                                    return [4 /*yield*/, response.json()];
                                case 1:
                                    json = _a.sent();
                                    logger_1.default.getInstance().add("Config Server responded: " + JSON.stringify(json, null, 2), logLevel_1.default.DEBUG);
                                    config = this.loadRemoteConfig(json);
                                    retries.stop();
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function (e) {
                        logger_1.default.getInstance().add("Fetching Remote Config Failed on retry number: " + iterator + ". Server says " + e, logLevel_1.default.WARNING);
                    });
                }, {
                    repeating_time: 100,
                    iterations: 3
                });
                retries.start();
                retries.onEnd = function () {
                    config !== null ? onSuccess(config) : onFail("Fetching Remote Config Failed");
                    return;
                };
            });
        }
        catch (e) {
            var error = "Fetching Remote Config Failed. Error says " + e;
            logger_1.default.getInstance().add(error, logLevel_1.default.WARNING);
            onFail(error);
        }
    };
    ;
    DiveSDK.prototype.loadRemoteConfig = function (data) {
        var config = this.remoteConfig.GetRemoteConfig(data);
        if (config !== null && config.metadataExperiments) {
            this.SetCustomHeaderParam('metadata_experiments', config.metadataExperiments);
        }
        return config;
    };
    DiveSDK.prototype.fetchRemoteConfig = function (url) {
        return fetch(url, {
            method: 'GET',
            headers: {
                'origin': "*",
            }
        });
    };
    ;
    DiveSDK.DEFAULT_CONFIG = {
        AppToken: "",
        Environment: "",
        HashKey: "",
        HasIdentityConsent: true,
        Logger: {
            level: logLevel_1.default.DEBUG
        },
        AnalyticsURL: "/events",
        ServerURL: "",
        ApiURL: "",
        GameVersion: "",
        ShowLogs: true,
        Domain: ""
    };
    return DiveSDK;
}());
exports.default = DiveSDK;
//# sourceMappingURL=diveSdk.js.map